import { MensajesDeError } from "@/utils/BusesDeEventos.js";
let switchErrors = function(error, componente, excepciones = []) {
  let mensaje = "";
  let titulo = "";
  let tipo = "onError";
  let dobleBotonera = false;
  let ayuda = false;
  let codigo = null;
  let excepcion = null;
  if (error && (error.data || error.response || error.status)) {
    if (excepciones.length > 0) {
      let codigoError = error.status || error.response.status;
      excepcion = excepciones.find(excepcionTemp => {
        return "" + excepcionTemp.codigo === "" + codigoError;
      });
      if (excepcion) {
        mensaje = excepcion.mensaje;
        codigo = excepcion.codigo;
        if (codigo == 503 || codigo == 404) {
          tipo = "onAlerta";
          titulo = "Notificación";
        }
      }
    }
    if (!excepcion) {
      switch (error.status || error.response.status) {
        case 204:
          titulo = "Registro fallido";
          mensaje = "Por favor intenta de nuevo";
          break;
        case 401:
          titulo = "Error para Iniciar Sesión";
          mensaje =
            "Datos no coinciden, por favor verificar que su run y contraseña son correctos.";
          break;
        case 406:
          titulo = "Error para Iniciar Sesión";
          mensaje =
            "Datos no coinciden, por favor verificar que su run y contraseña son correctos.";
          break;
        case 404:
          titulo = "No encontrado";
          tipo = "onAlerta";
          mensaje =
            "Los datos ingresados no han sido encontrados, por favor revisa y vuelve a intentar";
          break;
        case 400:
          if (error.data && error.data.errores) {
            let values = Object.keys(error.data.errores).map(function(key) {
              return dictionary[key];
            });
            mensaje = values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.errores) {
              let values = Object.keys(error.response.data.errores).map(
                function(key) {
                  return error.response.data.errores[key][0];
                }
              );
              mensaje = values[0];
            }
          }
          break;
        case 409:
          titulo = "Este RUN ya está registrado";
          tipo = "onAlerta";
          mensaje =
            "Si recuerdas tu clave Inicia sesión, de lo contrario recupera tu contraseña";
          dobleBotonera = true;
          break;
        case 500:
          titulo = "Error";
          if (componente.$el.id === "Inicio") {
            mensaje =
              "No se ha podido ingresar al sistema de admisión, por favor intentar de nuevo.";
          } else if (componente.$el.id === "Registro") {
            titulo = "Registro fallido";
            tipo = "onAlerta";
            mensaje = "Por favor intenta de nuevo";
          } else {
            mensaje =
              "No se ha podido realizar la operación, por favor intentar de nuevo.";
            ayuda = true;
          }
          break;
        case 503:
          titulo = "Fuera de Servicio";
          mensaje =
            "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad.";
          break;
        default:
          titulo = "Error";
          mensaje =
            "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad";
      }
    }
  } else {
    if (error.message) {
      mensaje = error.message;
    } else {
      mensaje =
        "Los servicios se encuentran temporalmente fuera de servicio, por favor reintentar a la brevedad";
    }
  }
  if (mensaje.length > 0) {
    MensajesDeError.$emit(tipo, mensaje, titulo, dobleBotonera, ayuda, codigo);
  } else {
    console.warn("Error sin mensaje");
  }
};

export default { switchErrors };



// WEBPACK FOOTER //
// ./src/utils/Errores.js